import React, { Component } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { ReactComponent as UsersIconOutlined } from 'assets/img/Users.svg';

// eslint-disable-next-line no-unused-vars
const styles = {
	svgContainer: {
		textAlign: 'center',
	},
};

class UsersIcon extends Component {
	render() {
		return (
			<SvgIcon {...this.props}>
				<UsersIconOutlined />
			</SvgIcon>
		);
	}
}

export default (UsersIcon);